import { useQuery } from "@tanstack/react-query";
import { api } from "../utils/apiClient";
import type { AirlineGroup, GroupsResponse } from "../types";

const fetchGroups = async (): Promise<AirlineGroup[]> => {
  const res = await api.get("/api/v1/groups");
  const data: GroupsResponse = await res.json();
  return data.groups;
};

export const useGroupsQuery = () => {
  return useQuery({
    queryKey: ["/api/v1/groups"],
    queryFn: fetchGroups,
    staleTime: 5 * 60 * 1000,
  });
};
